<div class="ag-text-filter" data-sui-popover-boundary>
  <sui-form-field>
    <label sui-label [attr.for]="uid + '-operator'">
      <fa-icon
        class="ag-text-filter__label-icon"
        [icon]="['fas', 'font']"
        aria-hidden="true"
      ></fa-icon>
      {{ "ag-text-filter.label.operator" | translate }}
    </label>
    <sui-select
      [id]="uid + '-operator'"
      [ngModel]="operator"
      (ngModelChange)="onOperatorChange($event)"
    >
      @for (op of operators; track op) {
        <sui-select-option [value]="op" [label]="operatorLabel(op)">{{
          operatorLabel(op)
        }}</sui-select-option>
      }
    </sui-select>
  </sui-form-field>
  @if (needsValue) {
    <sui-form-field>
      <label sui-label [attr.for]="uid + '-value'">
        {{ "ag-text-filter.label.value" | translate }}
      </label>
      <sui-input
        [id]="uid + '-value'"
        [(ngModel)]="text"
        [placeholder]="'ag-text-filter.placeholder.value' | translate"
        (keydown.enter)="apply()"
      ></sui-input>
    </sui-form-field>
  }
  <div class="ag-text-filter__footer">
    <sui-button
      class="ag-text-filter__cancel"
      size="sm"
      variant="secondary"
      (click)="cancel()"
    >
      {{ "btn.cancel" | translate }}
    </sui-button>
    <sui-button size="sm" variant="secondary" (click)="reset()">
      {{ "ag-date-range-filter.button.reset" | translate }}
    </sui-button>
    <sui-button
      size="sm"
      variant="primary"
      [disabled]="!canApply"
      (click)="apply()"
    >
      {{ "btn.apply" | translate }}
    </sui-button>
  </div>
</div>
